const host = {
    hostname:process.env.REACT_APP_API_URL
}
export default host